/*
 * Module for the search bar of the substitution group page
 */

define([
  "marionette",
  "messaging/messenger",
  "backbone.syphon",
  "modules/substitutions/substitutionSearch/substitutionSearchView",
  "modules/substitutions/substitutionSearch/substitutionSearchModel",
], function (
  Marionette,
  Messenger,
  BackboneSyphon,
  SubstitutionSearchView,
  SubstitutionSearchModel,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "substitutionSearch";
      this.region = options.region;
    },
    show: function () {
      this.view = new SubstitutionSearchView.substitutionSearchView({
        model: new SubstitutionSearchModel.substitutionSearchModel(),
      });
      this.view.on("click:search", function (args) {
        //save before search
        Messenger.save(function (success) {
          if (success) {
            const data = BackboneSyphon.serialize(args.view);
            //if search field is empty, then don't do the search
            if (data.searchField !== null && data.searchField.length > 0) {
              //set search field
              args.model.set("search", data.searchField);
              args.model.set("noResults", false); //set this now so that it won't change an old "No results for" to "No
              // results for {newSearchTerm}" before searching
              Messenger.vent.trigger("click:search", data);
            }
          }
        }, this);
      });
      this.view.on("clear:search", function (args) {
        args.model.set("search", "");
        args.model.set("filterByEntry", true);
        Messenger.vent.trigger("clear:search");
      });
      this.view.on(
        "change:filter:mode",
        function (args) {
          const oldSearch = this.view.getSearchValue();
          args.model.set("filterByEntry", !args.model.get("filterByEntry"));
          this.view.setSearchValue(oldSearch);
        },
        this,
      );
      this.showRegion(this.view);
    },

    setNoResults: function (noResults) {
      if (noResults) {
        this.view.model.set("noResults", true);
      } else {
        this.view.model.set("noResults", false);
      }
    },
  });
});
